// extracted by mini-css-extract-plugin
export default {"Network":"Network_Network__CAizo"};